export const RadiiPrimitives = {
  0: "0px",
  2: "2px",
  4: "4px",
  6: "6px",
  8: "8px",
  12: "12px",
  circular: "100%",
  full: "9999px",
} as const;
